import type { Tone } from './types';

/** Tone colours from the Dead Ink palette: disaster red, bad bruise, mixed newsprint, good cyan, windfall caption gold. */
export const TONE_COLORS: Record<Tone, string> = {
  disaster: '#e3242b',
  bad: '#4b3f5e',
  mixed: '#b9b8a8',
  good: '#3da5c8',
  windfall: '#f3c846',
};

/** `key=value` lines → a map (blank lines and lines without `=` are skipped). */
export function parseContext(text: string): Record<string, string> {
  const out: Record<string, string> = {};
  for (const line of text.split('\n')) {
    const i = line.indexOf('=');
    if (i <= 0) continue;
    out[line.slice(0, i).trim()] = line.slice(i + 1).trim();
  }
  return out;
}
